import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared';

type AscProjectsAnalyticIds = {
  mergeProjectsAnalyticId: string;
  confirmMergeProjectsAnalyticId: string;
  cancelMergeProjectsAnalyticId: string;
  createAscProjectAnalyticId: string;
};

export const useAscProjectsAnalyticIds = (): AscProjectsAnalyticIds => ({
  mergeProjectsAnalyticId: useAnalyticId(AnalyticIdentifier.RTC_ASC_MERGE_PROJECTS),
  confirmMergeProjectsAnalyticId: useAnalyticId(AnalyticIdentifier.RTC_CONFIRM_MERGE_ASC_PROJECTS),
  cancelMergeProjectsAnalyticId: useAnalyticId(AnalyticIdentifier.RTC_CANCEL_MERGE_ASC_PROJECTS),
  createAscProjectAnalyticId: useAnalyticId(AnalyticIdentifier.CREATE_ASC_PROJECT_BUTTON),
});
